<template>
  <div class="egresos-container">
    <div class="form">
      <el-container>
        <el-main>
          <el-form
            :model="form"
            ref="refId"
            :rules="rules"
            @presubmit.prevent
          >
            <div>
              <p class="label-style">EGRESOS MENSUALES EN PROMEDIO</p>
              <el-form style="margin-top:20px;">
              <div class="row-no-center">
                <el-form-item prop="expenseWater" class="medium" label="Agua">
                  <el-input v-model="form.expenseWater" />
                </el-form-item>
                <el-form-item prop="expenseLight" class="medium" label="Luz">
                  <el-input v-model="form.expenseLight" />
                </el-form-item>
                <el-form-item prop="expensePhone" class="medium" label="Teléfono / Internet Fijo">
                  <el-input v-model="form.expensePhone" />
                </el-form-item>
                <el-form-item prop="expenseCellPhone" class="medium" label="Celular">
                  <el-input v-model="form.expenseCellPhone" />
                </el-form-item>
                <el-form-item prop="expenseGas" class="medium" label="Gas">
                  <el-input v-model="form.expenseGas" />
                </el-form-item>
              </div>
              <div class="row-no-center">
                <el-form-item prop="expenseFood" class="medium lh" label="Alimentación">
                  <el-input v-model="form.expenseFood" />
                </el-form-item>
                <el-form-item
                  prop="expenseHouseSupplies"
                  class="medium"
                  label="Productos de limpieza o mantenimiento del hogar"
                >
                  <el-input v-model="form.expenseHouseSupplies" />
                </el-form-item>
                <el-form-item prop="expenseHealth" class="medium lh" label="Gastos de cuidado">
                  <el-input v-model="form.expenseHealth" />
                </el-form-item>
                <el-form-item prop="expenseSupport" class="medium lh" label="Salud">
                  <el-input v-model="form.expenseSupport" />
                </el-form-item>
                <el-form-item prop="expenseEducation" class="medium lh" label="Educación">
                  <el-input v-model="form.expenseEducation" />
                </el-form-item>
              </div>
              <div class="row-no-center">
                <el-form-item prop="expenseRent" class="medium" label="Renta">
                  <el-input v-model="form.expenseRent" />
                </el-form-item>
                <el-form-item
                  prop="expenseTransport"
                  class="medium"
                  label="Gasolina y/o transporte público"
                >
                  <el-input v-model="form.expenseTransport" />
                </el-form-item>
                <el-form-item prop="expenseCreditCard" class="medium" label="Tarjetas de crédito">
                  <el-input v-model="form.expenseCreditCard" />
                </el-form-item>
                <!-- <el-form-item prop="expenseCreditCard"
                  class="medium" label="Trabajo de Cuidados">
                  <el-input v-model="form.expenseCreditCard" />
                </el-form-item> -->
                <el-form-item prop="expenseOther" class="medium" label="Otros">
                  <el-input v-model="form.expenseOther" />
                </el-form-item>
              </div>

              <div class="row-no-center">
                <div>
                  <p class="label-style">TOTAL INGRESOS</p>
                  <el-tag type="success">
                    {{ currencyFormater(incomeTotal) }}
                  </el-tag>
                </div>
                <div style="width:20px" />
                <div>
                  <p class="label-style">TOTAL EGRESOS</p>
                  <el-tag type="warning">
                    {{ currencyFormater(outcomeTotal) }}
                  </el-tag>
                </div>
                <div style="width:20px" />
                <div>
                  <p class="label-style">REMANENTE O DEUDA</p>
                  <el-tag type="info">
                    <b>
                      {{ currencyFormater(incomeTotal - outcomeTotal) }}
                    </b>
                  </el-tag>
                </div>
              </div>

              <el-form-item
                class="med-lg"
                prop="incomeReceipts"
                label="Se mostraron comprobantes de ingresos"
                style="margin-top:10px;"
              >
                <el-select v-model="form.incomeReceipts">
                  <el-option
                    v-for="item in tf"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </el-form-item>
              <el-form-item
                class="med-lg"
                prop="outcomeReceipts"
                label="Se mostraron comprobantes de egresos"
                style="margin-top:10px;"
              >
                <el-select v-model="form.outcomeReceipts">
                  <el-option
                    v-for="item in tf"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </el-form-item>
              <el-button
                type="primary"
                size="small"
                style="margin-top:10px; margin-bottom:10px;background-color: #6a41bdca;"
                @click="updateEconomy"
              >
              Guardar Egresos Mensuales
              </el-button>
              </el-form>
            </div>
          </el-form>
        </el-main>
      </el-container>
    </div>
  </div>
</template>

<script>
import currencyFormater from '../../utils/currencyFormater';
import optionsMixin from '../../views/evaluations/SocioEconomic/mixin/options';

export default {
  props: {
    incomeTotal: {
      type: Number,
      default: 0,
    },
    idAppointment: {
      type: String,
      default: null,
    },
    recreate: {
      type: Boolean,
      default: null,
    },
  },
  data() {
    const isDecimal = (rule, value, cb) => {
      const regexp = /^[0-9]+([,.][0-9]+)?$/g;
      if (value && !regexp.test(value)) {
        return cb(new Error('El campo debe ser un numero decimal.'));
      }
      return cb();
    };
    return {
      form: {
        patientId: null,
        evaluationId: null,
        motivoEvaluacion: null,
        residenceTimeAtTijuana: null,
        academicDegree: null,
        houseCodition: null,
        houseWalls: null,
        houseFloor: null,
        houseRoof: null,
        houseRoomsLivingRoom: false,
        houseRoomsDiningRoom: false,
        houseRoomsKitchen: false,
        houseRoomsBathroom: null,
        houseRoomsBedroom: null,
        houseRoomsStudyingRoom: false,
        houseRoomsCourtyard: false,
        houseRoomsOther: false,
        serviceLight: false,
        serviceSewerSystem: false,
        serviceCableTV: false,
        servicePhone: false,
        serviceInternet: false,
        serviceAsphaltStreet: false,
        servicePublicWater: false,
        serviceGaslp: false,
        serviceOther: false,
        houseStuffFridge: false,
        houseStuffStove: false,
        houseStuffMicrowaveOven: false,
        houseStuffBlender: false,
        houseStuffWashingMachine: false,
        houseStuffDryer: false,
        houseStuffComputer: false,
        houseStuffDiningRoomSet: false,
        houseStuffLivingRoomSet: false,
        houseStuffBedroomSet: false,
        houseStuffTV: false,
        houseStuffDishWasher: false,
        car: null,
        expenseWater: null,
        expenseLight: null,
        expensePhone: null,
        expenseCellPhone: null,
        expenseGas: null,
        expenseFood: null,
        expenseHouseSupplies: null,
        expenseHealth: null,
        expenseSupport: null,
        expenseEducation: null,
        expenseRent: null,
        expenseTransport: null,
        expenseCreditCard: null,
        expenseOther: null,
        incomeReceipts: null,
        outcomeReceipts: null,
        familySituationDescription: null,
        comments: null,
        evaluationResult: null,
        programApplied: null,
        cost: null,
        area: null,
        classification: null,
        currency: null,
      },
      rules: {
        expenseWater: [
          {
            validator: isDecimal,
          },
        ],
        expenseLight: [
          {
            validator: isDecimal,
          },
        ],
        expensePhone: [
          {
            validator: isDecimal,
          },
        ],
        expenseCellPhone: [
          {
            validator: isDecimal,
          },
        ],
        expenseGas: [
          {
            validator: isDecimal,
          },
        ],
        expenseFood: [
          {
            validator: isDecimal,
          },
        ],
        expenseHouseSupplies: [
          {
            validator: isDecimal,
          },
        ],
        expenseHealth: [
          {
            validator: isDecimal,
          },
        ],
        expenseSupport: [
          {
            validator: isDecimal,
          },
        ],
        expenseEducation: [
          {
            validator: isDecimal,
          },
        ],
        expenseRent: [
          {
            validator: isDecimal,
          },
        ],
        expenseTransport: [
          {
            validator: isDecimal,
          },
        ],
        expenseCreditCard: [
          {
            validator: isDecimal,
          },
        ],
        expenseOther: [
          {
            validator: isDecimal,
          },
        ],

      },
      loadingService: null,
      loading: false,
      hasSelfOccupation: false,
      anteriorValue: 0,
    };
  },
  mixins: [optionsMixin],
  computed: {
    outcomeTotal() {
      let outcome = 0;
      outcome += parseFloat((this.form.expenseWater ?? 0) || (this.form.expenseWater === 'NaN' ? null : 0));
      outcome += parseFloat((this.form.expenseLight ?? 0) || (this.form.expenseLight === 'NaN' ? null : 0));
      outcome += parseFloat((this.form.expensePhone ?? 0) || (this.form.expensePhone === 'NaN' ? null : 0));
      outcome += parseFloat((this.form.expenseCellPhone ?? 0) || (this.form.expenseCellPhone === 'NaN' ? null : 0));
      outcome += parseFloat((this.form.expenseGas ?? 0) || (this.form.expenseGas === 'NaN' ? null : 0));
      outcome += parseFloat((this.form.expenseFood ?? 0) || (this.form.expenseFood === 'NaN' ? null : 0));
      outcome += parseFloat((this.form.expenseHouseSupplies ?? 0) || (this.form.expenseHouseSupplies === 'NaN' ? null : 0));
      outcome += parseFloat((this.form.expenseHealth ?? 0) || (this.form.expenseHealth === 'NaN' ? null : 0));
      outcome += parseFloat((this.form.expenseSupport ?? 0) || (this.form.expenseSupport === 'NaN' ? null : 0));
      outcome += parseFloat((this.form.expenseSupport ?? 0) || (this.form.expenseSupport === 'NaN' ? null : 0));
      outcome += parseFloat((this.form.expenseEducation ?? 0) || (this.form.expenseEducation === 'NaN' ? null : 0));
      outcome += parseFloat((this.form.expenseRent ?? 0) || (this.form.expenseRent === 'NaN' ? null : 0));
      outcome += parseFloat((this.form.expenseTransport ?? 0) || (this.form.expenseTransport === 'NaN' ? null : 0));
      outcome += parseFloat((this.form.expenseCreditCard ?? 0) || (this.form.expenseCreditCard === 'NaN' ? null : 0));
      outcome += parseFloat((this.form.expenseOther ?? 0) || (this.form.expenseOther === 'NaN' ? null : 0));
      return outcome;
    },
  },
  methods: {
    format() {
      return {
        patient: this.form.patientId,
        evaluationId: this.form.evaluationId,
        motivoEvaluacion: this.form.motivoEvaluacion,
        residenceTimeAtTijuana: this.form.residenceTimeAtTijuana,
        academicDegree: this.form.academicDegree,
        houseCondition: this.form.houseCondition,
        houseWalls: this.form.houseWalls,
        houseFloor: this.form.houseFloor,
        houseRoof: this.form.houseRoof,
        houseRoomsLivingRoom: this.form.houseRoomsLivingRoom,
        houseRoomsDiningRoom: this.form.houseRoomsDiningRoom,
        houseRoomsKitchen: this.form.houseRoomsKitchen,
        houseRoomsBathroom: this.form.houseRoomsBathroom,
        // houseRoomsBathroomQuantity: this.bathroom ? this.form.houseRoomsBathroomQuantity : null,
        houseRoomsBedroom: this.houseRoomsBedroom ? this.form.houseRoomsBedroom : null,
        houseRoomsStudyingRoom: this.form.houseRoomsStudyingRoom,
        houseRoomsCourtyard: this.form.houseRoomsCourtyard,
        houseRoomsOther: this.form.houseRoomsOther,
        serviceLight: this.form.serviceLight,
        serviceSewerSystem: this.form.serviceSewerSystem,
        serviceCableTV: this.form.serviceCableTV,
        servicePhone: this.form.servicePhone,
        serviceInternet: this.form.serviceInternet,
        serviceAsphaltStreet: this.form.serviceAsphaltStreet,
        servicePublicWater: this.form.servicePublicWater,
        serviceGaslp: this.form.serviceGaslp,
        serviceOther: this.form.serviceOther,
        houseStuffFridge: this.form.houseStuffFridge,
        houseStuffStove: this.form.houseStuffStove,
        houseStuffMicrowaveOven: this.form.houseStuffMicrowaveOven,
        houseStuffBlender: this.form.houseStuffBlender,
        houseStuffWashingMachine: this.form.houseStuffWashingMachine,
        houseStuffDryer: this.form.houseStuffDryer,
        houseStuffComputer: this.form.houseStuffComputer,
        houseStuffDiningRoomSet: this.form.houseStuffDiningRoomSet,
        houseStuffLivingRoomSet: this.form.houseStuffLivingRoomSet,
        houseStuffBedroomSet: this.form.houseStuffBedroomSet,
        houseStuffTV: this.form.houseStuffTV,
        houseStuffDishWasher: this.form.houseStuffDishWasher,
        car: this.form.car,
        expenseWater: parseFloat(this.form.expenseWater),
        expenseLight: parseFloat(this.form.expenseLight),
        expensePhone: parseFloat(this.form.expensePhone),
        expenseCellPhone: parseFloat(this.form.expenseCellPhone),
        expenseGas: parseFloat(this.form.expenseGas),
        expenseFood: parseFloat(this.form.expenseFood),
        expenseHouseSupplies: parseFloat(this.form.expenseHouseSupplies),
        expenseHealth: parseFloat(this.form.expenseHealth),
        expenseSupport: parseFloat(this.form.expenseSupport),
        expenseEducation: parseFloat(this.form.expenseEducation),
        expenseRent: parseFloat(this.form.expenseRent),
        expenseTransport: parseFloat(this.form.expenseTransport),
        expenseCreditCard: parseFloat(this.form.expenseCreditCard),
        expenseOther: parseFloat(this.form.expenseOther),
        incomeReceipts: this.form.incomeReceipts,
        outcomeReceipts: this.form.outcomeReceipts,
        familySituationDescription: this.form.familySituationDescription,
        comments: this.form.comments,
        evaluationResult: this.form.evaluationResult,
        programApplied: this.form.evaluationResult === this.evaluationResult[1].value
          ? this.form.programApplied : null,
        cost: this.form.cost,
        classification: this.form.classification,
        currency: this.form.currency,
        area: this.form.area,
      };
    },
    currencyFormater,
    async getData(patientId) {
      try {
        const response = await this.axios.get(`patient/newsocial/details/${patientId}`);
        if (response.data.appointmentId === this.idAppointment) {
          this.isFirstEvaluation = false;
        } else {
          this.isFirstEvaluation = true;
        }
        if (response.data) {
          const { data } = response;
          this.evaluationId = data.id;
          this.form = data;
          this.createdAt = data?.createdAt;
          const { houseRoomsBedroom } = data;
          this.houseRoomsBedroom = !!houseRoomsBedroom;

          const formClone = JSON.parse(JSON.stringify(this.form));
          this.initialForm = formClone;
          this.form.patientId = patientId;
        } else if (this.idAppointment.length <= 0) {
          this.open(patientId);
        }
      } catch (error) {
        this.$errorNotify(error);
      }
    },
    async updateEconomy() {
      try {
        const patientId = this.$route.params.id;
        const data = this.format();
        const request = this.axios.put(`patient/newSocial/${patientId}/${this.idAppointment}`, data);
        if (request) {
          this.loading = false;
          this.$notify({
            type: 'success',
            title: '¡Éxito!',
            message: 'Se han actualizado los datos correctamente',
          });
          await this.getData(patientId);
        }
      } catch (error) {
        // console.log(error);
      }
    },
  },
  async created() {
    const { id } = this.$route.params;
    this.form.patientId = id;
    await this.getData(id);
  },
  watch: {
    loading(val) {
      if (val && !this.loadingService) {
        this.loadingService = this.$loading({
          fullscreen: true,
          lock: true,
          text: 'Cargando',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)',
        });
      } else if (this.loadingService) {
        this.loadingService.close();
        this.loadingService = null;
      }
    },
    async recreate() {
      const { id } = this.$route.params;
      await this.getData(id);
    },
  },
};
</script>

<style lang="scss">
@import '../../views/evaluations/SocioEconomic/styles/style.scss';
</style>
<style lang="scss" scoped>
@import '../../views/evaluations/SocioEconomic/styles/style-scoped.scss';
</style>
